import { useMemo } from 'react';

import { FormSelect } from 'components';

import { useGetRequest } from 'hooks';

import { DisplayPriorityZones } from 'codegen';

export const ZoneSelect = () => {
  const { data } = useGetRequest<DisplayPriorityZones>({
    url: '/offers/display-zones',
  });

  const zones = useMemo(() => data?.displayZones?.map(({ id, name }) => ({ label: name, value: id })), [data?.displayZones]);

  return (
    <FormSelect
      label='Display Priority Zone'
      name={['zoneValue', 'displayPriorityZoneId']}
      options={zones}
      rules={[{
        message: 'Zone is required!',
        required: true,
      }]}
    />
  );
};
